import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthService } from './auth-service';
import { AuthGuard } from './auth-guard';
import { AuthErrorInterceptor } from './auth-error-interceptor';
import { OscNetworkStatusService } from '../services/network-status.service';
import { FeatureToggleService } from './feature-toggle.service';

@NgModule({
  providers: [    
    AuthService,
    AuthGuard,
    FeatureToggleService,
    OscNetworkStatusService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true }
  ]
})
export class OscAuthenticationModule { }
